@use "../../styles/mixins/component-wrapper" as wrapper;
@use "../../styles/mixins/accessibility" as *;

@include wrapper.layered-component {
  a {
    border: none; /* reset browser default borders */
    display: inline-block;
    cursor: pointer;
    font-family: var(--semantic-font-family-utility);
    font-size: var(--semantic-font-size-utility-m);
    font-style: normal;
    font-weight: var(--semantic-font-weight-utility-attention);
    line-height: var(--semantic-line-height-utility-m);
    letter-spacing: var(--semantic-letter-spacing-utility-m);
    text-decoration-line: underline;
    text-underline-position: from-font;
    transition: all var(--semantic-motion-duration-dynamic-medium-to-fast) var(--semantic-motion-easing-default-change);

    & i.icon {
      display: inline-block;
    }

    &.disabled {
      cursor: not-allowed;
    }

    &.icon-before {
      display: flex;

      .link-icon {
        margin-right: var(--semantic-spacing-content-m-gap-plain);
        font-size: 1px; /* reset font size - prevent change on link height when use icon */
        line-height: 1; /* reset line height - prevent change on link height when use icon */
      }
    }

    &.icon-after {
      display: flex;

      .link-icon {
        order: 1;
        margin-left: var(--semantic-spacing-content-m-gap-plain);
        font-size: 1px; /* reset font size - prevent change on link height when use icon */
        line-height: 1; /* reset line height - prevent change on link height when use icon */
      }
    }

    /* SIZE */
    &.s {
      font-size: var(--semantic-font-size-utility-s);
      line-height: var(--semantic-line-height-utility-s);
      letter-spacing: var(--semantic-letter-spacing-utility-s);
    }

    &.primary {
      color: var(--semantic-color-action-primary-resting);

      &:hover {
        color: var(--semantic-color-action-primary-hover);
        text-decoration: underline transparent;
      }

      &:active {
        color: var(--semantic-color-action-primary-active);
        transform: scale(var(--semantic-scaling-shrink-s));
      }

      &.disabled {
        color: var(--semantic-color-action-primary-disabled);
        text-decoration: underline;
        transform: none;
        user-select: none;
      }

      &.inverse {
        color: var(--semantic-color-action-primary-inverse-resting);

        &:hover {
          color: var(--semantic-color-action-primary-inverse-hover);
        }

        &:active {
          color: var(--semantic-color-action-primary-inverse-active);
        }

        &.disabled {
          color: var(--semantic-color-action-primary-inverse-disabled);
        }
      }
    }

    &.secondary {
      color: var(--semantic-color-action-secondary-resting);

      &:hover {
        color: var(--semantic-color-action-secondary-hover);
        text-decoration: underline transparent;
      }

      &:active {
        color: var(--semantic-color-action-secondary-active);
        transform: scale(var(--semantic-scaling-shrink-s));
      }

      &.disabled {
        color: var(--semantic-color-action-secondary-disabled);
        text-decoration: underline;
        transform: none;
        user-select: none;
      }

      &.inverse {
        color: var(--semantic-color-action-secondary-inverse-resting);

        &:hover {
          color: var(--semantic-color-action-secondary-inverse-hover);
        }

        &:active {
          color: var(--semantic-color-action-secondary-inverse-active);
        }

        &.disabled {
          color: var(--semantic-color-action-secondary-inverse-disabled);
        }
      }
    }

    &:focus-visible {
      @include accessibility-focus;
    }
  }
}
